import css from 'styled-jsx/css';

const staticStyles = css.global`
  .PaymentsConfirmOtpForm {
    padding: 32px 24px;
    background: #fafafa;
    border-radius: 12px;

    &__wrapper {
      display: flex;
      flex-direction: column;
    }

    &__message-enter-code {
      font-weight: 500;
      font-size: 18px;
      margin-bottom: 16px;
    }

    &__code-field {
      display: flex;
      gap: 16px;
    }

    .ReduxTextField {
      width: 100%;
    }

    .BaseTextField__inp {
      background: #fff;
    }

    .BaseTextField__label {
      z-index: 1111;
    }

    &__submit-button {
      height: 53px;
    }

    &__cancel-button {
      margin-top: 24px;
      align-self: flex-end;
    }
  }
`;

const getDynamicStyles = ({ colors }) => {
  return css.global`
    .PaymentsConfirmOtpForm {
      &__cancel-button {
        color: ${colors.black.hex} !important;
        border-color: #f0f0f0 !important;

        &:hover {
          background: #f0f0f0 !important;
        }
      }
    }
  `;
};

export { staticStyles, getDynamicStyles };
